var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "enroll-config" },
    [
      _c(
        "el-form",
        {
          ref: "formRef",
          staticClass: "form-container",
          attrs: { model: _vm.form, rules: _vm.rules, "label-width": "120px" },
        },
        [
          _c("div", { staticClass: "form-layout" }, [
            _c("div", { staticClass: "form-col form-col-main" }, [
              _c("div", { staticClass: "section-card" }, [
                _c("div", { staticClass: "section-card-header" }, [
                  _vm._v("\n            基本信息\n          "),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "section-card-body" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "大标题", prop: "title" } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "100%" },
                          attrs: { placeholder: "请输入大标题" },
                          model: {
                            value: _vm.form.title,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "title", $$v)
                            },
                            expression: "form.title",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "小标题", prop: "title2" } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            type: "textarea",
                            rows: 3,
                            placeholder: "请输入小标题",
                          },
                          model: {
                            value: _vm.form.title2,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "title2", $$v)
                            },
                            expression: "form.title2",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "消耗积分", prop: "points" } },
                      [
                        _c("el-input-number", {
                          staticStyle: { width: "200px" },
                          attrs: { min: 0 },
                          model: {
                            value: _vm.form.points,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "points", $$v)
                            },
                            expression: "form.points",
                          },
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "form-hint" }, [
                          _vm._v("报名消耗积分，0=免费"),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "封面图", prop: "imgUrl" } },
                      [
                        _c("image-upload", {
                          model: {
                            value: _vm.form.imgUrl,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "imgUrl", $$v)
                            },
                            expression: "form.imgUrl",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "开奖客服图", prop: "drawImgUrl" } },
                      [
                        _c("image-upload", {
                          model: {
                            value: _vm.form.drawImgUrl,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "drawImgUrl", $$v)
                            },
                            expression: "form.drawImgUrl",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "规则图", prop: "gzImgUrl" } },
                      [
                        _c("image-upload", {
                          model: {
                            value: _vm.form.gzImgUrl,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "gzImgUrl", $$v)
                            },
                            expression: "form.gzImgUrl",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "报名规则", prop: "rule" } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            type: "textarea",
                            rows: 6,
                            placeholder: "请输入报名规则",
                          },
                          model: {
                            value: _vm.form.rule,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "rule", $$v)
                            },
                            expression: "form.rule",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "是否启用", prop: "isEnable" } },
                      [
                        _c("el-switch", {
                          attrs: {
                            "active-value": 1,
                            "inactive-value": 0,
                            "active-text": "启用",
                            "inactive-text": "禁用",
                          },
                          model: {
                            value: _vm.form.isEnable,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "isEnable", $$v)
                            },
                            expression: "form.isEnable",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "section-card" }, [
                _c("div", { staticClass: "section-card-header" }, [
                  _vm._v("\n            时间设置\n          "),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "section-card-body" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "活动时间", prop: "timeRange" } },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            type: "datetimerange",
                            "range-separator": "至",
                            "start-placeholder": "开始时间",
                            "end-placeholder": "结束时间",
                            "value-format": "yyyy-MM-dd HH:mm:ss",
                          },
                          model: {
                            value: _vm.timeRange,
                            callback: function ($$v) {
                              _vm.timeRange = $$v
                            },
                            expression: "timeRange",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "开奖时间", prop: "drawTime" } },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            type: "datetime",
                            placeholder: "请选择开奖时间",
                            "value-format": "yyyy-MM-dd HH:mm:ss",
                          },
                          model: {
                            value: _vm.form.drawTime,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "drawTime", $$v)
                            },
                            expression: "form.drawTime",
                          },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-hint-block" }, [
                          _vm._v(
                            "\n                开奖时间需晚于活动结束时间，到期后由系统执行开奖\n              "
                          ),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "section-card" }, [
                _c("div", { staticClass: "section-card-header" }, [
                  _vm._v("\n            奖励配置\n          "),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "section-card-body" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "奖励数量", prop: "stock" } },
                      [
                        _c("el-input-number", {
                          staticStyle: { width: "200px" },
                          attrs: {
                            min: _vm.isEdit ? _vm.originalStock || 0 : 0,
                          },
                          model: {
                            value: _vm.form.stock,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "stock", $$v)
                            },
                            expression: "form.stock",
                          },
                        }),
                        _vm._v(" "),
                        _vm.isEdit
                          ? _c("div", { staticClass: "form-hint-block" }, [
                              _vm._v(
                                "\n                当前数量：" +
                                  _vm._s(_vm.originalStock) +
                                  "，只能增加不能减少\n              "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-hint-block" }, [
                          _vm._v(
                            "\n                奖励数量即发券库存，开奖时最多产生该数量的中奖用户\n              "
                          ),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "reward-block" },
                      [
                        _c("div", { staticClass: "reward-block-title" }, [
                          _vm._v(
                            "\n                中奖奖品\n                "
                          ),
                          _c("span", { staticClass: "reward-block-hint" }, [
                            _vm._v(
                              "（中奖用户发放的优惠券，每位中奖用户按以下配置发放）"
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.rewardItems, function (item, index) {
                          return _c(
                            "div",
                            { key: "item-" + index, staticClass: "reward-row" },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "320px" },
                                  attrs: {
                                    placeholder: "请选择优惠券",
                                    filterable: "",
                                    clearable: "",
                                    size: "small",
                                  },
                                  model: {
                                    value: item.typeId,
                                    callback: function ($$v) {
                                      _vm.$set(item, "typeId", $$v)
                                    },
                                    expression: "item.typeId",
                                  },
                                },
                                _vm._l(_vm.bonusList, function (bonus) {
                                  return _c("el-option", {
                                    key: bonus.typeId,
                                    attrs: {
                                      label:
                                        "[" +
                                        bonus.typeId +
                                        "] " +
                                        bonus.typeName,
                                      value: bonus.typeId,
                                    },
                                  })
                                }),
                                1
                              ),
                              _vm._v(" "),
                              _c("el-input-number", {
                                staticStyle: {
                                  "margin-left": "10px",
                                  width: "130px",
                                },
                                attrs: { min: 1, size: "small" },
                                model: {
                                  value: item.num,
                                  callback: function ($$v) {
                                    _vm.$set(item, "num", $$v)
                                  },
                                  expression: "item.num",
                                },
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "reward-num-label" }, [
                                _vm._v("张"),
                              ]),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  staticStyle: {
                                    color: "#F56C6C",
                                    "margin-left": "10px",
                                  },
                                  attrs: { type: "text", size: "small" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.removeRewardItem(index)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                  删除\n                "
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        }),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", icon: "el-icon-plus" },
                            on: { click: _vm.addRewardItem },
                          },
                          [_vm._v("\n                添加奖品\n              ")]
                        ),
                      ],
                      2
                    ),
                  ],
                  1
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-col form-col-side" }, [
              _c("div", { staticClass: "section-card" }, [
                _c("div", { staticClass: "section-card-header" }, [
                  _vm._v("\n            报名设置\n          "),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "section-card-body" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "自定义输入标题1", prop: "input1" } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: "注：输入需要填写的内容，空则不启用",
                          },
                          model: {
                            value: _vm.form.input1,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "input1", $$v)
                            },
                            expression: "form.input1",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "自定义输入标题2", prop: "input2" } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: "注：输入需要填写的内容，空则不启用",
                          },
                          model: {
                            value: _vm.form.input2,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "input2", $$v)
                            },
                            expression: "form.input2",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "自定义输入标题3", prop: "input3" } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: "注：输入需要填写的内容，空则不启用",
                          },
                          model: {
                            value: _vm.form.input3,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "input3", $$v)
                            },
                            expression: "form.input3",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "section-card" }, [
                _c("div", { staticClass: "section-card-header" }, [
                  _vm._v("\n            资格限制\n          "),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "section-card-body" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "会员级别" } },
                      [
                        _c(
                          "el-checkbox",
                          {
                            attrs: {
                              indeterminate: _vm.isLevelIndeterminate,
                              value: _vm.isLevelAllChecked,
                            },
                            on: { change: _vm.handleCheckAllLevel },
                          },
                          [_vm._v("\n                全选\n              ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-checkbox-group",
                          {
                            model: {
                              value: _vm.userLevelsChecked,
                              callback: function ($$v) {
                                _vm.userLevelsChecked = $$v
                              },
                              expression: "userLevelsChecked",
                            },
                          },
                          _vm._l(_vm.gradeOptions, function (grade) {
                            return _c(
                              "el-checkbox",
                              { key: grade.id, attrs: { label: grade.id } },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(grade.name) +
                                    "\n                "
                                ),
                              ]
                            )
                          }),
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-hint-block" }, [
                          _vm._v(
                            "\n                不勾选 = 不限等级\n              "
                          ),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "用户标签" } },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              multiple: "",
                              filterable: "",
                              clearable: "",
                              placeholder: "不选择 = 不限标签",
                            },
                            model: {
                              value: _vm.userTagsChecked,
                              callback: function ($$v) {
                                _vm.userTagsChecked = $$v
                              },
                              expression: "userTagsChecked",
                            },
                          },
                          _vm._l(_vm.tagOptions, function (tag) {
                            return _c("el-option", {
                              key: tag.id,
                              attrs: { label: tag.name, value: tag.id },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "企微用户" } },
                      [
                        _c("el-switch", {
                          attrs: {
                            "active-value": 1,
                            "inactive-value": 0,
                            "active-text": "仅企微",
                            "inactive-text": "不限",
                          },
                          model: {
                            value: _vm.form.userWw,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "userWw", $$v)
                            },
                            expression: "form.userWw",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "参与地区" } },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              multiple: "",
                              filterable: "",
                              clearable: "",
                              placeholder: "请选择参与地区",
                            },
                            on: { change: _vm.handleZoneChange },
                            model: {
                              value: _vm.zoneChecked,
                              callback: function ($$v) {
                                _vm.zoneChecked = $$v
                              },
                              expression: "zoneChecked",
                            },
                          },
                          [
                            _c("el-option", {
                              attrs: { label: "全国", value: 0 },
                            }),
                            _vm._v(" "),
                            _vm._l(_vm.cityOptions, function (city) {
                              return _c("el-option", {
                                key: city.regionId,
                                attrs: {
                                  label: city.regionName,
                                  value: city.regionId,
                                  disabled: _vm.isNationwide,
                                },
                              })
                            }),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "section-card" }, [
                _c("div", { staticClass: "section-card-header" }, [
                  _vm._v("\n            通知配置\n          "),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "section-card-body" }, [
                  _c(
                    "div",
                    { staticClass: "notice-block" },
                    [
                      _c("div", { staticClass: "reward-block-title" }, [
                        _vm._v("\n                开始通知\n              "),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "通知用户" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.form.startNoticeUser,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "startNoticeUser", $$v)
                                },
                                expression: "form.startNoticeUser",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v(
                                  "\n                    可参与活动用户\n                  "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v(
                                  "\n                    全部用户\n                  "
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "发送短信" } },
                        [
                          _c("el-switch", {
                            attrs: {
                              "active-value": 1,
                              "inactive-value": 0,
                              "active-text": "发送",
                              "inactive-text": "不发送",
                            },
                            model: {
                              value: _vm.form.startNoticeSms,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "startNoticeSms", $$v)
                              },
                              expression: "form.startNoticeSms",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.form.startNoticeSms === 1
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "短信模版ID" } },
                            [
                              _c("el-input", {
                                staticStyle: { width: "100%" },
                                attrs: { placeholder: "请输入短信模版ID" },
                                model: {
                                  value: _vm.form.startNoticeSmsTemplateId,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "startNoticeSmsTemplateId",
                                      $$v
                                    )
                                  },
                                  expression: "form.startNoticeSmsTemplateId",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "微信消息" } },
                        [
                          _c("el-switch", {
                            attrs: {
                              "active-value": 1,
                              "inactive-value": 0,
                              "active-text": "发送",
                              "inactive-text": "不发送",
                            },
                            model: {
                              value: _vm.form.startNoticeWxsms,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "startNoticeWxsms", $$v)
                              },
                              expression: "form.startNoticeWxsms",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.form.startNoticeWxsms === 1
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "微信模版ID" } },
                            [
                              _c("el-input", {
                                staticStyle: { width: "100%" },
                                attrs: { placeholder: "请输入微信模版ID" },
                                model: {
                                  value: _vm.form.startNoticeWxTemplateId,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "startNoticeWxTemplateId",
                                      $$v
                                    )
                                  },
                                  expression: "form.startNoticeWxTemplateId",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "社区消息" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              type: "textarea",
                              rows: 6,
                              placeholder: "活动开始前提醒（空=不发社区消息）",
                            },
                            model: {
                              value: _vm.form.startNoticeSqtitle,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "startNoticeSqtitle", $$v)
                              },
                              expression: "form.startNoticeSqtitle",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-hint-block notice-hint" },
                        [
                          _vm._v(
                            "\n                在活动开始前发送\n              "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "notice-block" },
                    [
                      _c("div", { staticClass: "reward-block-title" }, [
                        _vm._v("\n                开奖通知\n              "),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "中奖通知用户" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.form.drawNoticeUser,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "drawNoticeUser", $$v)
                                },
                                expression: "form.drawNoticeUser",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v(
                                  "\n                    中奖用户\n                  "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v(
                                  "\n                    全部用户\n                  "
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "发送短信" } },
                        [
                          _c("el-switch", {
                            attrs: {
                              "active-value": 1,
                              "inactive-value": 0,
                              "active-text": "发送",
                              "inactive-text": "不发送",
                            },
                            model: {
                              value: _vm.form.drawNoticeSms,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "drawNoticeSms", $$v)
                              },
                              expression: "form.drawNoticeSms",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.form.drawNoticeSms === 1
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "短信模版ID" } },
                            [
                              _c("el-input", {
                                staticStyle: { width: "100%" },
                                attrs: { placeholder: "请输入短信模版ID" },
                                model: {
                                  value: _vm.form.drawNoticeSmsTemplateId,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "drawNoticeSmsTemplateId",
                                      $$v
                                    )
                                  },
                                  expression: "form.drawNoticeSmsTemplateId",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "微信消息" } },
                        [
                          _c("el-switch", {
                            attrs: {
                              "active-value": 1,
                              "inactive-value": 0,
                              "active-text": "发送",
                              "inactive-text": "不发送",
                            },
                            model: {
                              value: _vm.form.drawNoticeWxsms,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "drawNoticeWxsms", $$v)
                              },
                              expression: "form.drawNoticeWxsms",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.form.drawNoticeWxsms === 1
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "微信模版ID" } },
                            [
                              _c("el-input", {
                                staticStyle: { width: "100%" },
                                attrs: { placeholder: "请输入微信模版ID" },
                                model: {
                                  value: _vm.form.drawNoticeWxTemplateId,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "drawNoticeWxTemplateId",
                                      $$v
                                    )
                                  },
                                  expression: "form.drawNoticeWxTemplateId",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "社区消息" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              type: "textarea",
                              rows: 6,
                              placeholder: "开奖后提醒（空=不发社区消息）",
                            },
                            model: {
                              value: _vm.form.drawNoticeSqtitle,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "drawNoticeSqtitle", $$v)
                              },
                              expression: "form.drawNoticeSqtitle",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-hint-block notice-hint" },
                        [
                          _vm._v(
                            "\n                在开奖后发送\n              "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-actions" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.loading },
                  on: { click: _vm.handleSubmit },
                },
                [_vm._v("\n        保存\n      ")]
              ),
              _vm._v(" "),
              _c("el-button", { on: { click: _vm.handleCancel } }, [
                _vm._v("\n        取消\n      "),
              ]),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }